/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * NotFound.ts
 */

import APIError from "./APIError";

export default class NotFound extends APIError {
    constructor(message: string) {
        super("Resource introuvable", 404, message);
    }
}